function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.715 13.082a.56.56 0 00-.756.211L21.16 16.46c-.145-6.139-2.916-11.663-7.236-14.267a8.62 8.62 0 00-7.461-.62A10.719 10.719 0 00.025 8.508a.545.545 0 00.367.684.558.558 0 00.694-.355 9.621 9.621 0 015.767-6.241 7.493 7.493 0 016.49.526c4.082 2.462 6.743 8.046 6.707 13.982l-3.012-2.887a.563.563 0 00-.786.013.54.54 0 00.01.77l4.015 3.845a.558.558 0 00.388.155.678.678 0 00.08-.005.552.552 0 00.405-.276l2.78-4.895a.54.54 0 00-.215-.741z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.022 24h12.957A1.022 1.022 0 0015 22.979v-8.66a1.019 1.019 0 00-.062-.338.476.476 0 00-.031-.062 1.031 1.031 0 00-.096-.194l-2.356-3.297a1.025 1.025 0 00-.832-.428H3.377a1.024 1.024 0 00-.832.428L.19 13.725a1.021 1.021 0 00-.098.196.48.48 0 00-.03.057A1.016 1.016 0 000 14.32v8.66A1.023 1.023 0 001.022 24zM1 22.979l.004-8.327h12.995L13.98 23zm10.64-11.97h.001l1.884 2.643H8V11h3.623a.02.02 0 01.018.009zM3.378 11H7v2.652H1.474z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.251 18h-3.5a.787.787 0 00-.75.82v1.347a.787.787 0 00.738.832l.012.001h3.5a.787.787 0 00.751-.82v-1.347a.787.787 0 00-.738-.832zm-.25 2h-3v-1h3z"
});

function SvgArtifactSkipped(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "artifactSkipped.0fffe.svg";
export { SvgArtifactSkipped as ReactComponent };